import React from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { FeedbackForm } from "./FeedbackForm";
import { selectUserInfo } from "../../routes/Auth/auth.ducks";
import { setContactModalVisible } from "../../containers/App/actions";
import { selectIsContactModalVisible } from "../../containers/App/selectors";
import styles from "./contactButton.scss"
import { getWindowWidth, isMediumScreen } from "../../services/utils";
import { Button } from "../Button/Button";

export const ContactButton = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const isFeedbackModalVisible = useSelector(selectIsContactModalVisible);
  const mobile = isMediumScreen(getWindowWidth());


  const handleClick = (e) => {
    e.preventDefault();
    dispatch(setContactModalVisible(true));
  };

  const handleCloseModal = () => {
    dispatch(setContactModalVisible(false));
  }

  return (
    <React.Fragment>
      {!mobile && (
        <div className={styles.contactButtonWrapper}>
          <Button
            onClick={handleClick}
            className={styles.contactButton}
            icon="message"
            type="primary"
            size="small"
          >
            Javite mišljenje
          </Button>
        </div>
      )}

      <Modal
        title="Pošaljite nam povratnu informaciju"
        width={520}
        footer={null}
        visible={isFeedbackModalVisible}
        onCancel={handleCloseModal}
      >
        <FeedbackForm
          email={userInfo && userInfo.email}
          onClose={handleCloseModal}
          isFeedbackModalVisible={isFeedbackModalVisible}
        />
      </Modal>

    </React.Fragment>
  );

}



// WEBPACK FOOTER //
// ./src/components/ContactButton/ContactButton.tsx